// import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
// import "bootstrap/dist/css/bootstrap.min.css"; //import "bootstrap/dist/css/bootstrap.min.css";
// import { registerServiceWorker } from './serviceWorker'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/asblk/firebase-messaging-sw.js')
    .then(function (registration) {
      // eslint-disable-next-line no-console
      console.log('[SW]: SCOPE: ', registration.scope);
      return registration.scope;
    })
    .catch(function (err) {
      return err;
    });
}

ReactDOM.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>,
  document.getElementById("rooterast")
);
//registerServiceWorker()

/*
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
*/
